import * as React from "react";
const SvgIcLineChartUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: "800px", height: "800px", viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("title", null, "ionicons-v5-c"), /* @__PURE__ */ React.createElement("polyline", { points: "352 144 464 144 464 256", style: {
  fill: "none",
  stroke: "#0ecc83",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("polyline", { points: "48 368 192 224 288 320 448 160", style: {
  fill: "none",
  stroke: "#0ecc83",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 32
} }));
export default SvgIcLineChartUp;
